class GithubApi {
    url = 'https://api.github.com/users/';

    getUserDetails(user) {
        return fetch(`${this.url}${user}`).then((res) => {
            if (res.ok) {
                return res.json()
              } else {
                return Promise.reject('Not Found or something went wrong!')
              }
        });
    }

}

export default GithubApi;


// WEBPACK FOOTER //
// ./src/services/github/index.js